import Vue from 'vue';
import Router from 'vue-router';
import home from '@/components/home';
import pro from '@/components/pro';
import about from '@/components/about';
import academy from "@/components/academy";
import contact from "@/components/contact";
import talents from "@/components/talents";
import build from "@/components/build";
import refer from "@/components/refer";
import hire from "@/components/hire";
import term from "@/components/term";
import faq from "@/components/faq";
import policy from "@/components/policy";
import portfolio from "@/components/portfolio";
import project from "@/components/project";
import talent from "@/components/talent";
import payment from "@/components/payment";
import webdevelopment from "@/components/webdevelopment";
import mobiledevelopment from "@/components/mobiledevelopment";
import datascience from "@/components/datascience";
import productdesign from "@/components/productdesign";
import disclaimer from "@/components/disclaimer";
import CaseStudiesSoftwareProject from "@/components/Case-Studies-Software-Project";
import eko from "@/components/eko";
import tracka from "@/components/tracka";
import anfana from "@/components/anfana";
import equalyz from "@/components/equalyz";
import CaseStudiesTalentPlacement from "@/components/Case-Studies-Talent-Placement";
import talentpillar from "@/components/talentpillar";
import talentgdl from "@/components/talentgdl";
import talentklak from "@/components/talentklak";
import talentriby from "@/components/talentriby";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: 'Hire African Software Developers | Build with Findworka',
        description: 'Find top vetted and experienced software developers or build your digital product with Findworka. Trusted by startups and enterprises worldwide.'
      }
    },
    {
      path: '/build',
      name: 'build',
      component: build,
      meta: {
        title: 'Build Your Software Product with Expert Developers | Findworka',
        description: 'Get a vetted team of software engineers to design, develop, and scale your software product. From MVP to enterprise-grade apps, Findworka delivers.'
      }
    },
    {
      path: '/pro',
      name: 'pro',
      component: pro,
      meta: {
        title: 'Join Findworka Pro | Get Hired for Remote Tech Projects',
        description: 'Apply to Findworka Pro and get matched with global projects that suit your skills. For developers, designers, and tech professionals.'
      }
    },
    {
      path: '/academy',
      name: 'academy',
      component: academy,
      meta: {
        title: 'Learn In-Demand Tech Skills | Findworka Academy',
        description: 'Kickstart your tech career with training in coding, design, and AI. Join the Findworka Academy and become globally competitive.'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: 'About Findworka | Software Engineers Building the Future',
        description: 'Findworka helps you find the right software engineers to build powerful digital solutions. 50+ tech stacks. Onboard in 72 hours.'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: 'Contact Findworka | Hire Software Developers for Team or Software Project',
        description: 'Reach out to hire talent, build software products, or learn more about our services. Findworka is here to support your growth.'
      }
    },
    {
      path: '/refer',
      name: 'refer',
      component: refer,
      meta: {
        title: 'Refer a Friend and Earn | Findworka Referral Program',
        description: 'Know someone who needs tech talent? Refer them to Findworka and get rewarded for every client onboarded.'
      }
    },
    {
      path: '/hire',
      name: 'hire',
      component: hire,
      meta: {
        title: 'Hire Pre-Vetted African Developers | Hire by Findworka',
        description: 'Hire experienced African software developers, designers, and tech talent for your startup or company.Fast, reliable, and vetted for performance.'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      meta: {
        title: 'Questions about Hiring African Developers | Findworka Support',
        description: 'Get answers to common questions about hiring tech talent from Africa and more.'
      }
    },

    // other routes (no meta needed if not prerendered for SEO)
    { path: '/talents', name: 'talents', component: talents },
    { path: '/term', name: 'term', component: term },
    { path: '/policy', name: 'policy', component: policy },
    { path: '/portfolio', name: 'portfolio', component: portfolio },
    { path: '/project', name: 'project', component: project },
    { path: '/talent', name: 'talent', component: talent },
    { path: '/payment', name: 'payment', component: payment },
    { path: '/webdevelopment', name: 'webdevelopment', component: webdevelopment },
    { path: '/mobiledevelopment', name: 'mobiledevelopment', component: mobiledevelopment },
    { path: '/datascience', name: 'datascience', component: datascience },
    { path: '/productdesign', name: 'productdesign', component: productdesign },
    { path: '/disclaimer', name: 'disclaimer', component: disclaimer },
    { path: '/Case-Studies-Software-Project', name: 'Case-Studies-Software-Project', component: CaseStudiesSoftwareProject },
    { path: '/eko', name: 'eko', component: eko },
    { path: '/tracka', name: 'tracka', component: tracka },
    { path: '/anfana', name: 'anfana', component: anfana },
    { path: '/equalyz', name: 'equalyz', component: equalyz },
    { path: '/Case-Studies-Talent-Placement', name: 'cstp', component: CaseStudiesTalentPlacement },
    { path: '/talentpillar', name: 'talentpillar', component: talentpillar },
    { path: '/talentgdl', name: 'talentgdl', component: talentgdl },
    { path: '/talentklak', name: 'talentklak', component: talentklak },
    { path: '/talentriby', name: 'talentriby', component: talentriby }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js